/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_fp_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How F1 Fantasy points are scored`)
};

const es_f1_fp_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cómo se puntúa en F1 Fantasy`)
};

const de_f1_fp_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie F1-Fantasy-Punkte vergeben werden`)
};

const nl_f1_fp_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe F1 Fantasy-punten worden toegekend`)
};

const fr_f1_fp_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment sont attribués les points F1 Fantasy`)
};

const it_f1_fp_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come vengono assegnati i punti F1 Fantasy`)
};

const pt_br2_f1_fp_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como os pontos do F1 Fantasy são distribuídos`)
};

const pt_f1_fp_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como são atribuídos os pontos de F1 Fantasy`)
};

const ja_f1_fp_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1ファンタジーポイントの獲得方法`)
};

const zh_f1_fp_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1梦幻积分是如何计算的`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_fp_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_fp_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_fp_title", locale)
	if (locale === "en") return en_f1_fp_title(inputs)
	if (locale === "es") return es_f1_fp_title(inputs)
	if (locale === "de") return de_f1_fp_title(inputs)
	if (locale === "nl") return nl_f1_fp_title(inputs)
	if (locale === "fr") return fr_f1_fp_title(inputs)
	if (locale === "it") return it_f1_fp_title(inputs)
	if (locale === "pt-BR") return pt_br2_f1_fp_title(inputs)
	if (locale === "pt") return pt_f1_fp_title(inputs)
	if (locale === "ja") return ja_f1_fp_title(inputs)
	return zh_f1_fp_title(inputs)
};